import { H1 } from '@expo/ui/src/typography';

export const NotFoundPage = () => {
  return <H1>Oops... The resource could not be found.</H1>;
};
